import React, { useMemo } from 'react';
import classNames from 'classnames';

import SelectWidget from 'components/UI/Form/Widget/SelectWidget/SelectWidget';
import { CartProduct as CartProductType } from 'types/Cart';

import styles from './CartProductQuantity.module.scss';

export default function CartProductQuantity({
  className,
  quantity,
  limitedQty,
  onQuantityChange,
}: Pick<CartProductType, 'quantity' | 'limitedQty'> & {
  className?: string;
  onQuantityChange: (quantity: string) => void;
}): JSX.Element {
  const options = useMemo(() => {
    return Array.from({ length: 9 }, (_, i) => i + 1).map(quantity => {
      const qty = quantity.toString();
      return { label: qty, value: qty };
    });
  }, []);
  const selectedOption = options.find(
    option => option.value === quantity.toString()
  );

  function handleChange(newValue) {
    onQuantityChange(newValue.value);
  }

  return (
    <SelectWidget
      className={classNames(styles.select, className)}
      classes={{
        control: styles.control,
        dropdownIndicator: styles.dropdownIndicator,
        menuPortal: styles.menuPortal,
        option: styles.option,
        singleValue: styles.singleValue,
        valueContainer: styles.valueContainer,
      }}
      isDisabled={limitedQty != 0}
      onChange={handleChange}
      options={options}
      value={selectedOption}
    />
  );
}
